var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"star-picto-64x64"},React.createElement("path",{"id":"Vector","d":"M16.1951 7.88116L18.6684 12.1602L19.0804 12.8732L19.881 13.0942L25.1611 14.5532L21.7232 17.4672L20.8385 18.2172L21.0511 19.3497L21.9575 24.1797L17.0367 21.9587L16.1956 21.5792L15.3545 21.9587L10.4337 24.1797L11.3401 19.3497L11.5527 18.2177L10.6685 17.4677L7.23009 14.5517L12.5097 13.0947L13.3109 12.8737L13.7233 12.1602L16.1966 7.88116M16.1966 3.84766L11.9656 11.1687L3.03809 13.6327L9.35064 18.9862L7.73467 27.5982L16.1966 23.7792L24.6586 27.5982L23.0426 18.9862L29.3552 13.6357L20.4276 11.1692L16.1966 3.84816V3.84766Z","fill":"#16B639"})));
}

Star.defaultProps = {"width":"33","height":"33","viewBox":"0 0 33 33","fill":"none"};

module.exports = Star;

Star.default = Star;
